module.exports = __webpack_public_path__ + "img/hotel-512.6d4f3065.png";